"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaintenanceReason = void 0;
var MaintenanceReason;
(function (MaintenanceReason) {
    MaintenanceReason["UNKNOWN"] = "Unknown";
    MaintenanceReason["MANUALLY"] = "Manually";
    MaintenanceReason["LIVE_MONITORING"] = "LiveMonitoring";
    MaintenanceReason["CERTIFICATES_UPDATE"] = "CertificatesUpdate";
    MaintenanceReason["SECURITY_CENTER_PROVISIONING"] = "SecurityCenterProvisioning";
    MaintenanceReason["SECURITY_CENTER_BACKUP_SNAPSHOT"] = "SecurityCenterBackupSnapshot";
    MaintenanceReason["SECURITY_CENTER_BACKUP_RESTORE"] = "SecurityCenterBackupRestore";
    MaintenanceReason["SECURITY_CENTER_UPDATE"] = "SecurityCenterUpdate";
    MaintenanceReason["SECURITY_CENTER_DELETION"] = "SecurityCenterDeletion";
    MaintenanceReason["VIRTUAL_MACHINE_PROVISIONING"] = "VirtualMachineProvisioning";
    MaintenanceReason["VIRTUAL_MACHINE_BACKUP_RESTORE"] = "VirtualMachineBackupRestore";
    MaintenanceReason["KSC_AGENT_UPDATE"] = "KscAgentUpdate";
    MaintenanceReason["FLUSHING_VALUE_UPDATE"] = "FlushingValueUpdate";
    MaintenanceReason["SECURITY_CENTER_PARAMETERS_UPDATE"] = "SecurityCenterParametersUpdate";
    MaintenanceReason["CUSTOM_SCRIPT_EXECUTE"] = "CustomScriptExecute";
})(MaintenanceReason || (exports.MaintenanceReason = MaintenanceReason = {}));
